/** Gedeelde marketingteksten (landing + evt. e-mail). */
export const WAT_WE_DOEN_LEEK: string[] = [
  'Je ziet hoeveel vermogen je ongeveer nodig hebt om warm te blijven en om koel te blijven op een zware dag — per kamer en voor het hele huis.',
  'We houden rekening met muren, ramen, lucht die binnenkomt, zon op ramen en hoe jij het graag binnen hebt.',
  'Met je postcode koppelen we grofweg aan het weer in jouw streek voor een jaarschatting (geen huisnummer nodig).',
  'Je krijgt duidelijke indicatieve cijfers om te delen in je team of met een opdrachtgever — geen vervanger van een officieel energielabel of maatwerk-berekening.',
];

export const LANDING_FAQ: { q: string; a: string }[] = [
  {
    q: 'Is dit hetzelfde als een energielabel?',
    a: 'Nee. Je krijgt indicatieve vermogens en jaarschattingen op basis van je invoer — handig om te overleggen, geen officieel document.',
  },
  {
    q: 'Waar blijven mijn gegevens?',
    a: 'Je antwoorden bewaren we op jouw apparaat, zodat je de scan kunt pauzeren en later verder kunt gaan. Alleen als je weer per postcode, het uur-voor-uur-beeld of het uitgeschreven adviesrapport gebruikt, sturen we die gegevens beveiligd naar ComfortTool om het voor je te berekenen — zie ook privacy.',
  },
  {
    q: 'Wat kost het?',
    a: 'Richtprijzen hangen af van je oppervlakte en of je particulier of zakelijk bent. Op de prijzenpagina zie je het overzicht; het exacte bedrag zie je pas op de betaalpagina vlak voordat je betaalt.',
  },
];
